export default __webpack_public_path__ + "static/media/efl-iconfont.e7d44dd5.woff";